import axiosInstance from './AxiosInstance';

const API_URL = 'mte';

export const getMTE = async () => {
    try {
        const response = await axiosInstance.get(`${API_URL}/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching mte', error);
        throw error;
    }
};

export const getMTEByEmail= async (email) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/viewByEmail/${email}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching mte', error);
        return [];
    }
};

export const getMTEById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching mte with id ${id}`, error);
        throw error;
    }
};

export const createMTE = async (room) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, room);
        return response.data;
    } catch (error) {
        console.error('Error creating mte', error);
        throw error;
    }
};

export const updateMTE = async (id, room) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...room });
        return response.data;
    } catch (error) {
        console.error(`Error updating mte with id ${id}`, error);
        throw error;
    }
};

export const deleteMTE = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting mte with id ${id}`, error);
        throw error;
    }
};

export const importExcel = async (data) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/import-excel`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
        return response.data;
    } catch (error) {
        console.error('Error import-excel mte', error);
        throw error;
    }
};
